import { render } from "./ServiceButton.vue?vue&type=template&id=29a168f6&scoped=true"
import script from "./ServiceButton.vue?vue&type=script&lang=js"
export * from "./ServiceButton.vue?vue&type=script&lang=js"

import "./ServiceButton.vue?vue&type=style&index=0&id=29a168f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a168f6"]])

export default __exports__